import Layout from '../views/Layout.vue'
export default {
  path: '/room',
  name: '示范空间',
  component: Layout,
  iconCls: 'el-icon-user-solid',
  roles: ['AppUser'],
  hidden: false,
  children: [
    {
      path: '/room',
      component: () =>
                import('../views/room/index'),
      name: '优秀案例空间',
      roles: ['AppUser'],
      hidden: false
    },
    {
      path: '/room/roam',
      component: () =>
                import('../views/room/roam/index'),
      name: '漫游',
      roles: ['AppUser'],
      hidden: true
    }
  ]
}
